// extracted by mini-css-extract-plugin
export var inputContainer = "_of-0";